import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';

import { initModal, pushModal } from 'shared/actions/modal.action';

import {} from 'shared/actions/auth.action';

@connect(
  (state, props) => ({
    type: state.shared.modal.type,
    data: state.shared.modal.data,
  }),
  { initModal, pushModal },
)
class VideoPlayerContainer extends Component {
  componentDidMount() {}

  render() {
    const { data = {}, initModal } = this.props;

    let width = '650px';
    let height = '365px';
    let style = {
      fontSize: '28px',
      fontWeight: 'bold',
      letterSpacing: '-1.4px',
      lineHeight: '60px',
    };

    let closeStyle = { right: '20px', top: '20px' };

    if (window.isMobile) {
      width = '320px';
      height = '180px';

      style.fontSize = '14px';
      style.lineHeight = '40px';

      closeStyle.right = '10px';
      closeStyle.top = '10px';
    }

    return (
      <Dim onClick={initModal}>
        <div style={{ width, height, position: 'relative' }}>
          <div style={style}>{data.title}</div>
          {data.v ? (
            <iframe
              title="VideoPlayer"
              width={width}
              height={height}
              src={`https://www.youtube.com/embed/${data.v}`}
              frameBorder="0"
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
              controls="0"
              autoPlay="1"
              allowFullScreen="1"
            />
          ) : (
            ''
          )}
          <span
            className={`close-btn-ico`}
            style={closeStyle}
            onClick={initModal}
          ></span>
        </div>
      </Dim>
    );
  }
}

export default VideoPlayerContainer;
